export default {
  apiContactFormPostinId: '8263ff20-4854-41c8-a276-d0d04fc8435a',
  searchPlaceholder: 'Cerca nei prodotti...',
  searchPlaceholderProducts: 'Cerca prodotto...',
  yourData: 'I tuoi dati:',
  name: 'Nome*',
  surname: 'Cognome*',
  email: 'Email*',
  phone: 'Telefono*',
  city: 'Città*',
  role: 'Mansione',
  requestType: 'Tipo di richiesta',
  company: 'Azienda',
  message: 'Messaggio',
  termsExtLabel:
    'Acconsento al trattamento dei miei dati personali come da informativa e a ricevere via email o telefono le informazioni richieste tramite questo modulo.',
  newsletterExtLabel:
    'Desidero iscrivermi alla newsletter per rimanere aggiornato sulle novità di Bioenologia (potrai cancellarti in ogni momento attraverso il link presente in ogni newsletter che riceverai)',
  termsError: 'Accettare i termini e le condizioni',
  sendRequest: 'Invia richiesta',
  requests: 'Commerciale,Supporto,Altro',
  roles: 'Titolare,Enologo,Responsabile produzione',
  success: 'Richiesta inviata con successo',
  error: 'Si è verificato un errore',
  endMessage:
    'Bioenologia userà i dati personali unicamente per assolvere ai servizi richiesti e non cederà gli stessi a terzi a scopi pubblicitari. Potrai richiedere la rimozione dei tuoi dati dai nostri sistemi in qualsiasi momento tramite questo modulo.',

  // Product contact
  productContact: 'Richiedi informazioni<br> sul prodotto',
  forProduct: 'Prodotto selezionato:',
  forProducts: 'Prodotti selezionati:',
  otherProducts: 'Vuoi aggiungere altri prodotti alla tua richiesta?',
  otherProductsText:
    'Selezionali dalla lista o ricercali attraverso il campo di ricerca sottostante.',
}
